/** @format */

import Helpers from "./../library/Helpers";

export default class Header {
	constructor() {
		this.instance = self;
		this.lst = 0;
		this.isVisible = true;
	}

	static init() {
		const self = new Header();

		self.attachEvents();
	}

	static refreshHeader() {
		const self = new Header();

		self.setHeaderGhostSize().refreshSubNav();
	}

	attachEvents() {
		const self = this;

		// If no header-top, then make header fixed straight away
		if (!$(".header-top").length > 0) {
			$(".header-main").addClass("is-fixed");
		}

		self.setHeaderGhostSize().refreshSubNav();

		$(window).on(
			"resize",
			Helpers.debounce(function () {
				self.setHeaderGhostSize().refreshSubNav();
			}, 250)
		);

		document.addEventListener(
			"scroll",
			function () {
				self.toggleFixedHeader();
			},
			{ passive: true }
		);

		if (Modernizr.touchevents) {
			document.addEventListener(
				"touchmove",
				function () {
					self.toggleFixedHeader();
				},
				{ passive: true }
			);

			document.addEventListener(
				"touchend",
				function () {
					self.toggleFixedHeader();
				},
				{ passive: true }
			);
		}
	}

	setHeaderGhostSize() {
		const self = this,
			$headerMain = $(".header-main"),
			$headerTop = $(".header-top"),
			$ghost = $(".header-ghost");

		let height = $headerMain.outerHeight();

		if ($headerTop.length > 0) {
			$headerTop.each(function () {
				if ($(this).is(":visible")) {
					height += $(this).outerHeight();
				}
			});
		}

		$ghost.css({ height: height });

		return self;
	}

	toggleFixedHeader() {
		const self = this,
			$headerTop = $(".header-top");

		let offset = 0;

		if ($headerTop.length > 0) {
			$headerTop.each(function () {
				if ($(this).is(":visible")) {
					offset += $(this).outerHeight();
				}
			});
		}

		if ($(window).scrollTop() >= offset) {
			$(".header-main").addClass("is-fixed");
		} else {
			$(".header-main").removeClass("is-fixed");
		}
	}

	refreshSubNav() {
		const self = this;

		// console.log("refreshSubNav");

		const $subNav = $(".js-position-sub-nav");

		if ($subNav.length) {
			const windowWidth = $(window).width(),
				$siteWrapper = $(".site-wrapper");

			if (windowWidth < 992) {
				// console.log("refreshSubNav < 992");
				$siteWrapper.css("paddingBottom", $subNav.outerHeight());

				if ($subNav.hasClass("mod-sticky")) {
					$subNav.css("top", "");
				}
			} else if (windowWidth > 992) {
				// console.log("refreshSubNav > 992");
				$siteWrapper.css("paddingBottom", "");

				if ($subNav.hasClass("mod-sticky")) {
					const $headerMain = $(".header-main");
					$subNav.css("top", $headerMain.outerHeight());
				}
			}
		}

		return self;
	}
}
